/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    UploadBanner({ commit }, data) {
        return axios.post(http + '/setting/lunbo_save', data).then(res => {
            return res.data
        })
    },
    SetListShow({ commit }, data) {
        return axios.post(http + '/setting/lunbo_list', data).then(res => {
            return res.data
        })
    },
    AccessControlListShow ({ commit }, data) {
        return axios.post(http + '/guard/guard/show', data).then(res => {
            return res.data
        })
    },
    SaveAccessControl({ commit }, data) {
        return axios.post(http + '/guard/guard/edit', data).then(res => {
            return res.data
        })
    },
    DelAccessControl({ commit }, data) {
        return axios.post(http + '/guard/guard/delete', data).then(res => {
            return res.data
        })
    },
    AccessControlLogListShow ({ commit }, data) {
        return axios.post(http + '/guard/guard/guard_log', data).then(res => {
            return res.data
        })
    },
    AccessControlCardListShow ({ commit }, data) {
        return axios.post(http + '/guard/guard/cardlist', data).then(res => {
            return res.data
        })
    },
    SaveAccessControlCard ({ commit }, data) {
        return axios.post(http + '/guard/guard/edit_card', data).then(res => {
            return res.data
        })
    },
    DelAccessControlCard ({ commit }, data) {
        return axios.post(http + '/guard/guard/delete_card', data).then(res => {
            return res.data
        })
    }
    // 用户名登录
    // NoticeAdministrationListShow({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/show', data).then(res => {
    //         return res.data
    //     })
    // },
    // AddNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/add', data).then(res => {
    //         return res.data
    //     })
    // },
    // DeleteNoticeAdministration({ commit }, data) {
    //     data.ADMIN_ID = getAdminId();
    //     data.ADMIN_TOKEN = getToken();
    //     return axios.post(http + '/notice/delete', data).then(res => {
    //         return res.data
    //     })
    // }
};

const AccessControlModule = {
    state,
    getters,
    actions,
    mutations
}
export default AccessControlModule
